<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>
          回单订单基础信息
        </div>
        <div class="order-detail-box">
          <div class="label-val">
            <div class="label-1">订单编号</div>
            <div class="value-1">{{ form.orderNo }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">承运机构</div>
            <div class="value-1">{{ form.driverCompanyName }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">司机姓名</div>
            <div class="value-1">{{ form.driverName }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">手机号码</div>
            <div class="value-1">{{ form.driverPhone }}</div>
          </div>
        </div>
        <div class="title-box" v-if="form.fileIds && form.fileIds.length > 0">
          <el-image :src="cheImage" class="title-label"></el-image>
          纸质回单照片
        </div>
        <div class="common-image-box">
          <el-image
            v-for="(item, index) in form.fileIds"
            :key="index"
            :src="getFileUrl(item)"
            class="common-image"
            :preview-src-list="[getFileUrl(item)]"></el-image>
        </div>
        <template v-if="!isDetail">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>
            回单方式
          </div>
          <el-row :gutter="20">
            <el-form ref="form" :model="form" :rules="rules" label-position="top">
              <el-col :span="24">
                <el-form-item label="回单方式：" prop="receiptWay">
                  <el-radio-group v-model="form.receiptWay">
                    <el-radio :label="1">线下带回</el-radio>
                    <el-radio :label="2">快递寄回</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="form.receiptWay === 2">
                <el-form-item label="快递寄回：" prop="handleMsg">
                  <el-input
                    type="textarea"
                    clearable
                    rows="2"
                    placeholder="请输入快递公司及单号，如顺丰快递xxxx"
                    v-model="form.handleMsg"
                    maxlength="100"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </template>
        <template v-else>
          <template v-if="form.receiptWay && form.receiptWay !== 0">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>
            回单信息
          </div>
          <el-row class="common-info-box">
            <el-col :span="12">
              <span class="label">跟单人：</span>
              <span class="value">{{ form.handleUsername }}</span>
            </el-col>
            <el-col :span="12">
              <span class="label">操作时间：</span>
              <span class="value">{{ form.handleTime }}</span>
            </el-col>
            <el-col :span="12">
              <span class="label">回单方式：</span>
              <span class="value">
                <span v-if="form.receiptWay === 0">待确认</span>
                <span v-if="form.receiptWay === 1">线下带回</span>
                <span v-if="form.receiptWay === 2">快递寄回</span>
              </span>
            </el-col>
            <el-col :span="24">
              <span class="label">快递信息：</span>
              <span class="value">{{ form.handleMsg }}</span>
            </el-col>
          </el-row>
          </template>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { detailInfo, handleReceipt } from "./api";
import {getFileUrl} from "@/utils/tool";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      imageUrl: require("@/assets/imgs/bg.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "50%",
        show: false,
        title: "回单订单跟单",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        "handleMsg": "",
        "receiptId": "",
        "receiptWay": ""
      },
      rules: {
        receiptMethod: [{ required: true, message: "回单方式不能为空" }],
        sn: [{ required: true, message: "快递信息不能为空" }],
      },
      isDetail: false,
    };
  },
  mounted() {},
  methods: {
    getFileUrl,
    init(title, isDetail, row) {
      this.dialogObj.title = title;
      this.isDetail = isDetail;
      if (this.isDetail) {
        this.dialogObj.confirmFn = "";
      } else {
        this.dialogObj.confirmFn = this.submitForm;
      }
      if (!!row) {
        // this.form = Object.assign({}, this.form, row);
        this.getDetail(row.receiptId)
      }
      this.dialogObj.show = true;
    },
    getDetail(receiptId) {
      detailInfo(receiptId).then(res => {
          if (res.code === 200) {
            this.form = Object.assign({}, res.data);
          }
      })
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            receiptId: this.form.receiptId,
            handleMsg: this.form.handleMsg,
            receiptWay: this.form.receiptWay,
          };
          handleReceipt(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("提交成功");
                this.$parent.getDeptData();
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
}
</style>
